import React from "react";
import {
  NewModal as Modal,
  NewBox as Box,
  NewButton as Button,
  OverlayProvider,
  NewTypography as Typography,
  useViewport,
} from "@bca/ui-library";
import styled from "styled-components";

const StyledButton = styled(Button)`
  width: 100%;
`;

interface ConfirmationModalProps {
  showConfirmationModal: boolean;
  setShowConfirmationModal: React.Dispatch<React.SetStateAction<boolean>>;
  modalAction: () => void;
  actionTitle: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  showConfirmationModal,
  setShowConfirmationModal,
  modalAction,
  actionTitle,
}) => {
  const viewport = useViewport();
  const handleOnClose = () => setShowConfirmationModal(false);
  const handleYesButton = () => modalAction();

  return (
    <OverlayProvider>
      <Modal
        open={showConfirmationModal}
        shouldCloseOnBlur={false}
        role="dialog"
        maxWidth="600px"
        paddingX="lg"
        paddingY="lg"
      >
        <Modal.CloseBar onCloseClick={handleOnClose} gap="lg">
          <Typography variant="h5">
            Are you sure you want to {actionTitle}?
          </Typography>
        </Modal.CloseBar>
        <Modal.Body>
          <Typography variant="body-large" color="neutral_700">
            Any changes you have made will not be saved.
          </Typography>
        </Modal.Body>
        <Modal.Actions display="flex" gap="lg">
          <Box flex={viewport.is.xs ? 1 : "none"}>
            <StyledButton
              variant="secondary"
              text="No"
              onClick={(event) => {
                event.stopPropagation();
                handleOnClose();
              }}
            />
          </Box>
          <Box flex={viewport.is.xs ? 1 : "none"}>
            <StyledButton
              variant="primary"
              text="Yes"
              onClick={(event) => {
                event.stopPropagation();
                handleYesButton();
              }}
            />
          </Box>
        </Modal.Actions>
      </Modal>
    </OverlayProvider>
  );
};

export default ConfirmationModal;
